export default "<div >\r\n  <canvas id=\"{{elemId}}\" height=\"{{_height}}\">{{ chart }}</canvas>\r\n</div>";